module.exports = __webpack_public_path__ + "media/images/banners/Boiled Fish in chili oil-b50b4268c0b6b8c1ea0d634706c07359.JPG";